function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "45",
  height: "45"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_1549",
  "data-name": "Rectangle 1549",
  transform: "translate(.327 .328)",
  fill: "#453f94",
  d: "M0 0h30v30H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4056",
  "data-name": "Group 4056",
  transform: "translate(-677 -243)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Ellipse_22",
  "data-name": "Ellipse 22",
  d: "M22.5 2.5a20.006 20.006 0 00-7.784 38.429A20.006 20.006 0 0030.284 4.071 19.872 19.872 0 0022.5 2.5m0-2.5A22.5 22.5 0 110 22.5 22.5 22.5 0 0122.5 0z",
  transform: "translate(677 243)",
  fill: "#453f94"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_4042",
  "data-name": "Group 4042",
  transform: "translate(684.672 250.672)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4042-2",
  "data-name": "Group 4042",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1594",
  "data-name": "Path 1594",
  d: "M4.39 25.6A15 15 0 1014.993 0c-.117 0-.232.015-.349.017v15.007H0A14.935 14.935 0 004.39 25.6",
  fill: "#453f94"
}))))));